import React from 'react';
import { Helmet } from 'react-helmet';

const trackPageView = (newState) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: window.location.pathname + window.location.search,
    page_location: window.location.href,
    // newState.title is the value Helmet just committed to the DOM, so it's
    // never stale (document.title would still hold the previous page's
    // title here, since Helmet only updates it right before this callback).
    page_title: newState.title,
  });
};

const Seo = ({ title, description }) => {
  return (
    <Helmet
      title={title}
      onChangeClientState={trackPageView}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: description,
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: description,
        },
      ]}
    ></Helmet>
  );
};

export default Seo;
